/** SVG path that holds each value for an equal share of `width`. */
export function stepPath(
  values: number[],
  [min, max]: [number, number],
  width: number,
  height: number,
) {
  const step = width / values.length;
  const y = (value: number) => height - ((value - min) / (max - min)) * height;
  const segments = values.map(
    (value, i) => `${i === 0 ? "M0 " : `H${i * step}V`}${y(value)}`,
  );
  return `${segments.join("")}H${width}`;
}
